import { Popconfirm } from 'antd';
import React from 'react';

import { IBlockConfirm } from '@components/block-event-single/components/BlockConfirm/typed';

const popconfirmOkButtonStyle = {
  color: '#ff4d4f',
  borderRadius: '4px',
  border: '1px solid #FF4D4F',
  padding: '4px 8px',
  display: 'inline-flex',
  alignItems: 'center',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '-0.14px',
  height: '28px',
};

const popconfirmCancelButtonStyle = {
  ...popconfirmOkButtonStyle,
  color: '#0046FF',
  borderColor: '#0046FF',
};

const BlockConfirm: React.FC<IBlockConfirm> = ({ showConfirm, children, ...rest }) => {
  if (showConfirm) {
    return (
      <Popconfirm
        okText="Block"
        cancelButtonProps={{ type: 'default', style: popconfirmCancelButtonStyle }}
        okButtonProps={{
          danger: true,
          type: 'ghost',
          style: popconfirmOkButtonStyle,
        }}
        icon=""
        placement="bottomLeft"
        {...rest}
      >
        {children}
      </Popconfirm>
    );
  }
  return <>{children}</>;
};

export default BlockConfirm;
